import { axios, handleApiError } from "./Api";
import moment from "moment";

const MealPlanApi = {
  /**
   * Get Meals from client meal plans
   *
   * @param {moment} start
   * @param {moment} end
   */
  async getMeals(start, end) {
    return axios
      .get(axios.defaults.baseURL + "/mealplans/" + start.format("YYYY-MM-DD") + "/" + end.format("YYYY-MM-DD"))
      .then(response => {
        // Group meals by date
        let mealsByDate = {};
        response.data.meals.forEach(meal => {
          if (!mealsByDate.hasOwnProperty(meal.date)) {
            mealsByDate[meal.date] = [];
          }

          mealsByDate[meal.date].push(meal);
        });

        return mealsByDate;
      })
      .catch(handleApiError);
  },

  /**
   * Create New Once Off Meal Plan
   *
   * @param {moment} date
   * @param {array} meals
   */
  async newOnceOff(date, meals) {
    return axios
      .post(axios.defaults.baseURL + "/mealplans/onceoff", {
        date: date.format("YYYY-MM-DD"),
        meals: meals
      })
      .catch(handleApiError);
  },

  /**
   * Cancel Meal
   *
   * @param {int} type
   * @param {int} id
   * @param {moment} date
   */
  async cancelMeal(type, id, date) {
    return axios
      .post(axios.defaults.baseURL + "/mealplans/cancel", {
        type: type,
        id: id,
        date: date.format("YYYY-MM-DD")
      })
      .catch(handleApiError);
  },

  /**
   * Get Recurring Meal Plans
   */
  async getRecurringMealPlans() {
    return axios
      .get(axios.defaults.baseURL + "/mealplans/recurring")
      .then(response => {
        let mealPlans = [];

        Object.keys(response.data.mealplans).forEach(key => {
          let mealPlan = response.data.mealplans[key];
          mealPlan.start = moment(mealPlan.start);
          mealPlan.end = moment(mealPlan.end);

          mealPlans.push(mealPlan);
        });

        return mealPlans;
      })
      .catch(handleApiError);
  },

  /**
   * Get Recurring Meal Plan
   *
   * @param {int} plan_id
   */
  async getRecurringMealPlan(plan_id) {
    return axios
      .get(axios.defaults.baseURL + "/mealplan/recurring/" + plan_id)
      .then(response => {
        return response.data.mealplan;
      })
      .catch(handleApiError);
  },

  /**
   * New Recurring Meal Plan
   *
   * @param {int} menu_id
   * @param {string} start
   * @param {string} end
   * @param {array} meals
   */
  async newRecurringMealPlan(menu_id, start, end, meals) {
    return axios
      .post(axios.defaults.baseURL + "/mealplans/recurring/new", {
        menu_id: menu_id,
        start: start,
        end: end ? end : "",
        meals: meals,
        fortnightly: 0
      })
      .catch(handleApiError);
  }
};

export default MealPlanApi;
